import CardDesign from "../components/cardDesign";
import useAllTrendingProducts from "hook/useAllTrendingProducts";
import NewProducts from "components/dashboardComponents/newProducts";
import {FaStar, FaTag} from "react-icons/fa";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
import ScrollToTopButton from "components/ScrollToTopButton";
import trendingProductBanner from "../images/trendingProductBanner.webp";

const TrendingProductsFullPage = () => {
    const { allTrendingProducts, loading1, error } = useAllTrendingProducts();
    const { theme, language } = useSettings();
    const isDark = theme === "dark";

    return (
        <div className=" flex flex-col min-h-[100dvh]">
            <div className="relative rounded-md mb-5 md:max-w-7xl mx-auto ">
                {/* ✅ Data */}
                {!loading1 && !error && allTrendingProducts.length > 0 && (
                    <div className="mb-3">
                        <section className="relative overflow-hidden bg-gradient-to-r from-indigo-600 via-blue-600 to-cyan-500 text-white shadow-lg ">
                            <div className="relative ">
                                <div className="absolute inset-0">
                                    <img
                                        src={trendingProductBanner}
                                        alt="Trending Product banner"
                                        className="h-full w-full object-top opacity-50"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-r from-indigo-600/95 via-blue-600/85 to-cyan-500/70" />
                                </div>
                                <div className="relative flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between p-5">
                                    <div>
                                        <p className="inline-flex items-center justify-center gap-2 text-xs font-semibold uppercase tracking-widest text-emerald-100 leading-none">
                                            <FaStar className="text-sm shrink-0" />
                                            <span>{t("trending", language)}</span>
                                        </p>

                                        <h1 className="text-2xl font-extrabold sm:text-3xl py-2">
                                            {t("trendingProducts", language).toUpperCase()}
                                        </h1>
                                        <p className="mt-2 max-w-xl text-sm text-white/90 sm:text-base">
                                            {t("trendingTitle", language)}
                                        </p>
                                    </div>

                                    <div className="flex flex-wrap items-center gap-2">
                                      <span className="text-xs inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-2">
                                        <FaStar />
                                          {t("trendingNow", language)}
                                      </span>
                                        <span className={`text-xs inline-flex items-center gap-2 rounded-full border border-white/15 ${isDark ? "bg-gray-100 text-white" : "bg-white text-slate-900"} px-3 py-2`}>
                                            <FaTag />
                                            {t("mostPopular", language)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <CardDesign likeData={allTrendingProducts} />
                    </div>
                )}
            </div>
            <NewProducts />
            <ScrollToTopButton />
        </div>
    );
};

export default TrendingProductsFullPage;
